import React, { useContext, useEffect, useState } from 'react'
import Chat from './Chat'
import { ChatContext } from '../context/ChatContext'
import { onSnapshot } from 'firebase/firestore'
import { db } from '../config/firebase'
import { doc } from 'firebase/firestore'

const ChatMsg = () => {

  const [messages, setmessages] = useState([])
  const { data} = useContext(ChatContext)

  useEffect(()=>{
    const ubsub = onSnapshot(doc(db,"chats",data.chatId),(doc) =>{
      console.log(doc.data())
           doc.exists() && setmessages(doc.data().messages)
    })

    return () =>{
      ubsub();
    };
    
  },[data.chatId])
  
  return (
    <div className='chat-messages '>
      {messages.map((mes)=>(
           <Chat message ={mes} key={mes.id} />
      ))}

    </div>
  )
}

export default ChatMsg